import { CSSProperties } from 'react';
import { SvgSpriteName } from './types';
import styled from 'styled-components';
import { focusOutline } from '@ardoq/style-helpers';

const FocusableSvg = styled.svg<{ $isFocused: boolean }>`
  ${({ $isFocused }) => $isFocused && focusOutline}
`;

export type SvgSpriteIconProps = {
  symbolName: SvgSpriteName;
  width?: number | string;
  height?: number | string;
  style?: CSSProperties;
  className?: string;
  color?: string;
  isFocused?: boolean;
};

const SvgSpriteIcon = ({
  symbolName,
  isFocused,
  color,
  style,
  ...props
}: SvgSpriteIconProps) => (
  <FocusableSvg
    $isFocused={Boolean(isFocused)}
    {...props}
    style={color ? { ...style, color } : style}
    preserveAspectRatio="xMidYMid meet"
  >
    <use xlinkHref={`#${symbolName}`} />
  </FocusableSvg>
);

export { SvgSpriteIcon };
